import * as actions from "../action.constants";

const initialState = {
  userModalStatus: false,
  userModalData: {},
  usersData: {},
  profile: {},
};

const addUserModalStatus = (state, action) => {
  return {
    ...state,
    userModalStatus: action.payload,
  };
};

const addUserModalData = (state, action) => {
  return {
    ...state,
    userModalData: action.payload,
  };
};
const saveGetUsersList = (state, action) => {
  return {
    ...state,
    usersData: action.payload,
  };
};

const saveUserProfile = (state, action) => {
  return {
    ...state,
    profile: action.payload,
  };
};

const handlers = {
  [actions.SAVE_ADD_USER_MODAL_STATUS]: addUserModalStatus,
  [actions.SAVE_ADD_USER_MODAL_DATA]: addUserModalData,
  [actions.SAVE_GET_USERS_LIST]: saveGetUsersList,
  [actions.STORE_USER_PROFILE]: saveUserProfile,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
